import * as CookieManager from '../tools/Cookie';

const cookieName = 'OptanonConsent';
const oneTrustTag = {
  pinterest: 'optanon-category-4',
  googlePlus: 'optanon-category-4',
  twitter: 'optanon-category-4',
  facebook: 'optanon-category-4',
};
const oneTrustEnable = CookieManager.readCookie(cookieName);

function getOneTrustClassByTag(tag) {
  return oneTrustTag[tag];
}

function isOneTrustEnable() {
  return oneTrustEnable != null;
}

export {
  getOneTrustClassByTag,
  isOneTrustEnable,
};



// WEBPACK FOOTER //
// ./js/common/tools/OneTrustTagging.js